import { Link } from "react-router-dom";
import LogoMark from "../components/LogoMark";

function StaticShell({ children, title, eyebrow, testId }) {
  return (
    <div className="min-h-screen bg-[#050d1a] text-white">
      <header className="flex items-center justify-between px-6 lg:px-12 py-5 border-b border-[rgba(0,170,255,0.18)]">
        <LogoMark size={36} withText />
        <Link to="/" className="csc-btn-ghost" data-testid="back-home">← Back</Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-12" data-testid={testId}>
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.32em] text-[#39ff14]">{eyebrow}</div>
        <h1 className="text-3xl lg:text-4xl font-semibold mt-2 mb-6">{title}</h1>
        <div className="csc-card p-8 space-y-4 text-[#94a3b8] leading-relaxed text-[15px]">
          {children}
        </div>
      </main>
    </div>
  );
}

export const Terms = () => (
  <StaticShell eyebrow="Legal" title="Terms of Service" testId="terms-page">
    <p>
      Welcome to CyberSecurity4Charities.org. By creating an account, you agree to use the platform
      responsibly, to protect the confidentiality of any non-public information shared with you, and to
      respect the nonprofits, volunteers and security professionals you collaborate with.
    </p>
    <p>
      You are responsible for keeping your account credentials secure and for the activity that occurs
      under your account. Misuse of the platform — including harassment, phishing, malware distribution,
      or impersonating an organization — may result in account suspension.
    </p>
    <p>This is a placeholder. The final terms will be published before public launch.</p>
  </StaticShell>
);

export const Privacy = () => (
  <StaticShell eyebrow="Legal" title="Privacy Policy" testId="privacy-page">
    <p>
      We collect only what is necessary to operate the platform and protect our community: your name,
      email, organization (if applicable), and the content you choose to share.
    </p>
    <p>
      OTP verification codes and authentication tokens are stored hashed and never shared. We will never
      sell your data. Email outreach is opt-in and can be disabled in your settings at any time.
    </p>
    <p>This is a placeholder. The final policy will be published before public launch.</p>
  </StaticShell>
);

export const About = () => (
  <StaticShell eyebrow="About / Contact" title="Securing Today. Empowering Tomorrow." testId="about-page">
    <p>
      CyberSecurity4Charities.org is a community-led platform that gives nonprofits access to the security
      tools, training, and trusted experts they need to protect their missions — for free.
    </p>
    <p>
      We connect IT pros, cybersecurity analysts, students, donors, and journalists with the charities
      who need them most.
    </p>
    <p>
      Contact us: <a className="csc-link" href="mailto:hello@cybersecurity4charities.org">hello@cybersecurity4charities.org</a>
    </p>
  </StaticShell>
);

export const Donate = () => (
  <StaticShell eyebrow="Donate" title="Power the Mission" testId="donate-page">
    <p>
      Your donation funds free cybersecurity tooling, training programs, and incident response for
      charities around the world.
    </p>
    <p>
      Donation processing integrations (Stripe / PayPal) will be wired in shortly. For now, please reach
      out at <a className="csc-link" href="mailto:donate@cybersecurity4charities.org">donate@cybersecurity4charities.org</a>.
    </p>
  </StaticShell>
);
